"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import Stamp from "src/vendor/stamp";
const _Hashcash = class _Hashcash {
  constructor(input) {
    this.options = JSON.parse(input.getAttribute("data-hashcash"));
    this.input = input;
    this.disableParentForm();
    this.input.dispatchEvent(new CustomEvent("hashcash:mint", { bubbles: true }));
    this.mint((stamp) => {
      this.input.value = stamp.toString();
      console.log("Hashcash stamp: ", stamp);
      console.log("Hashcash input: ", this.input.value);
      this.enableParentForm();
      this.input.dispatchEvent(new CustomEvent("hashcash:minted", { bubbles: true, detail: { stamp } }));
    });
  }
  static setup() {
    if (document.readyState != "loading") {
      var input = document.querySelector("input#hashcash");
      input && new _Hashcash(input);
    } else
      document.addEventListener("DOMContentLoaded", _Hashcash.setup);
  }
  setSubmitText(submit, text) {
    if (!text) {
      return;
    }
    if (submit.tagName == "BUTTON") {
      !submit.originalValue && (submit.originalValue = submit.innerHTML);
      submit.innerHTML = text;
    } else {
      !submit.originalValue && (submit.originalValue = submit.value);
      submit.value = text;
    }
  }
  disableParentForm() {
    this.input.form.querySelectorAll("[type=submit]").forEach((submit) => {
      this.setSubmitText(submit, this.options["waiting_message"]);
      submit.disabled = true;
    });
  }
  enableParentForm() {
    this.input.form.querySelectorAll("[type=submit]").forEach((submit) => {
      this.setSubmitText(submit, submit.originalValue);
      submit.disabled = null;
    });
  }
  mint(callback) {
    var options = this.options;
    var resource = this.options.resource;
    var date = /* @__PURE__ */ new Date();
    var year = date.getFullYear().toString();
    year = year.slice(year.length - 2, year.length);
    var month = (date.getMonth() + 1).toString().padStart(2, "0");
    var day = date.getDate().toString().padStart(2, "0");
    var stamp = new Stamp(
      options.version || _Hashcash.default.version,
      options.bits || _Hashcash.default.bits,
      options.date || year + month + day,
      resource,
      options.extension || _Hashcash.default.extension,
      options.rand || Math.random().toString(36).substr(2, 10)
    );
    return stamp.work(callback);
  }
};
__publicField(_Hashcash, "default", {
  version: 1,
  bits: 20,
  extension: null
});
let Hashcash = _Hashcash;
export {
  Hashcash as default
};
